import { useEffect, useRef } from 'react';

const PAYPAL_SDK_URL =
  'https://www.paypal.com/sdk/js?client-id=BAAkadcS43OmUjwuWSPc1_CQuNX0Jn13G6UmmBJgJZqcBLKqE6NHBttaO6YpdCsOUf3WaXp4ukRINsU83Q&components=hosted-buttons&enable-funding=venmo&currency=USD';

declare global {
  interface Window {
    paypal?: {
      HostedButtons: (options: { hostedButtonId: string }) => {
        render: (container: string | HTMLElement) => Promise<void>;
      };
    };
  }
}

// Shared across all buttons so the SDK script is only added to the page once.
let sdkPromise: Promise<void> | null = null;

function loadPayPalSdk(): Promise<void> {
  if (window.paypal) return Promise.resolve();
  if (!sdkPromise) {
    sdkPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = PAYPAL_SDK_URL;
      script.async = true;
      script.crossOrigin = 'anonymous';
      script.onload = () => resolve();
      script.onerror = () => {
        sdkPromise = null;
        reject(new Error('Failed to load PayPal SDK'));
      };
      document.body.appendChild(script);
    });
  }
  return sdkPromise;
}

type Props = {
  hostedButtonId: string;
};

export function PayPalHostedButton({ hostedButtonId }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let cancelled = false;

    loadPayPalSdk()
      .then(() => {
        const container = containerRef.current;
        if (cancelled || !container || !window.paypal) return;
        // Clear any previous render (e.g. React StrictMode double-invoking effects).
        container.innerHTML = '';
        return window.paypal.HostedButtons({ hostedButtonId }).render(container);
      })
      .catch((err) => console.error(err));

    return () => {
      cancelled = true;
    };
  }, [hostedButtonId]);

  return <div id={`paypal-container-${hostedButtonId}`} ref={containerRef} />;
}
